<template>
  <div style="height: 100%">
    <fdc-panel
      :title="'컬럼 그룹 기능'"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="dataSortFilter"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'ColumnHeaderGroup',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 100).map(d => {
          d.date = d.date.split('/').reverse().join('/') // date format이 DD/MM/YYYY 여서 converting함
          return d
        })))
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        {
          headerName: '개인 정보',
          children: [
            { field: 'athlete', minWidth: 150, checkboxSelection: true },
            { field: 'age', maxWidth: 90, type: 'numericColumn' },
            { field: 'country', minWidth: 150 }
          ]
        },
        {
          headerName: '수상 정보',
          children: [
            { field: 'year', maxWidth: 90 },
            { field: 'date', minWidth: 150, type: 'dateColumn' },
            { field: 'sport', minWidth: 150 }
          ]
        },
        {
          headerName: '메달 정보',
          children: [
            { field: 'gold', type: 'numericColumn' },
            { field: 'silver', type: 'numericColumn' },
            { field: 'bronze', type: 'numericColumn' },
            { field: 'total', type: 'numericColumn' }
          ]
        }
      ],
      defaultColDef: {
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid 컬럼 정의를 children을 포함하여 구성',
        ' */',
        '// 그룹화 할 컬럼을 children 아래에 설정',
        '{',
        '\theaderName: \'메달 정보\',',
        '\tchildren: [',
        '\t\t{ field: \'gold\', type: \'numericColumn\' },',
        '\t\t{ field: \'silver\', type: \'numericColumn\' },',
        '\t\t{ field: \'bronze\', type: \'numericColumn\' },',
        '\t\t{ field: \'total\', type: \'numericColumn\' }',
        '\t]',
        '}'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
